import React, {Component} from "react"
import styles from "./Footer.module.css"

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <div className={styles.heading}>
                        <span>BELLUS ACADEMY</span>
                        <span className={styles.dot}>•</span>
                        <span className={styles.highlight}>CAMPUS LOCATIONS</span>
                    </div>
                    <div className={styles.addresses}>
                        <p className={styles.addressLine}>
                            POWAY, CA 13266 Poway Rd | Poway, CA 92064 | 858-748-1490
                        </p>
                        <p className={styles.addressLine}>
                            EL CAJON, CA 1073 E. Main St | El Cajon, CA 92021 | 619-442-3407
                        </p>
                        <p className={styles.addressLine}>
                            CHULA VISTA, CA 970 Broadway | Chula Vista, CA 91911 | 619-474-6607
                        </p>
                        <p className={styles.addressLine}>
                            MANHATTAN, KS 1130 Westloop Pl | Manhattan, KS 66502 | 785-539-1837
                        </p>
                    </div>
                    <div className={styles.copyright}>© Bellus Academy. All rights reserved.</div>
                </div>
            </footer>
        )
    }
}
